export const themeProp = {
  validator (value: string) {
    return value ? ['light', 'dark'].includes(value) : false;
  },
  default: 'light',
};
